// The browser copy of the Meta Purchase. Its event id is the Paddle transaction id, the same id the server sends,
// so Meta keeps one of the two.
import { type CheckoutEventsData } from "@paddle/paddle-js"
import { type OfferingProduct } from "../../features/payment/domain/models/offering"
import { buildMetaPurchaseCustomData } from "./meta-ads/meta-purchase-custom-data"

export const trackPixelInitiateCheckout = (offering: OfferingProduct): void => {
  try {
    window.fbq?.("track", "InitiateCheckout", {
      content_name: offering.name,
      content_ids: [offering.id],
      value: offering.price,
      currency: offering.currencyCode,
    })
  } catch (error) {
    console.error("Meta pixel error:", error)
  }
}

export const trackPixelPurchase = (data: CheckoutEventsData | undefined): void => {
  const transactionId = data?.transaction_id
  if (!transactionId) return
  try {
    window.fbq?.("track", "Purchase", buildMetaPurchaseCustomData(data), { eventID: transactionId })
  } catch (error) {
    console.error("Meta pixel error:", error)
  }
}
